<script setup lang="ts">
/**
 * A screen's title with the ☰ before it, top left, where the old app had its menu. The tab
 * bar stays: the menu is the old app's way round for those who know it, and the way to the
 * things that have no tab of their own -- updating, the boat, the activation, the manual.
 */
import { useAppStore } from '../store'
import { menuOpen } from '../lib/menu'

const store = useAppStore()
</script>

<template>
  <div class="titlebar">
    <button type="button" class="menubtn" :aria-label="store.t('menu')" aria-haspopup="dialog" :aria-expanded="menuOpen" @click="menuOpen = true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
    </button>
    <h1><slot /></h1>
  </div>
</template>
